import React, { useContext } from "react";
import { ChatAtendenteContext } from "../../../contexts/ChatAtendenteContext";
import { AppContext } from "../../../contexts/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComment, faHistory } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export function OpcoesIniciais(){
  const {userData} = useContext(AppContext);
  const {handleModoVisualizacao, atendimentoAtivo} = useContext(ChatAtendenteContext)

  return (
    <>
      <div className="user-section">
        <div>
          <span>Olá,</span>
          <span className="nome">{userData?.nome ?? "---"}</span>
        </div>            
        <span className="texto-auxiliar">Como podemos ajudar?</span>
      </div>
      <div className="btns-principal-section">
        <div 
          className="btn-option-principal" 
          onClick={()=>{
            handleModoVisualizacao('historico')  
          }}      
        >
          <div className="section-icon" style={{backgroundColor: "var(--dommus-color)" }}>
            <FontAwesomeIcon icon={faHistory as IconProp}/>
          </div>
          <span className="label">Histórico</span>
        </div>
        <div 
          className="btn-option-principal"
          onClick={()=>{
            if(atendimentoAtivo.id){
              handleModoVisualizacao('chat')  
            }else{
              handleModoVisualizacao('criar_atendimento')  
            }
          }}
        >
          <div className="section-icon" style={{backgroundColor: "var(--dommus-color-2)" }}>
            <FontAwesomeIcon icon={faComment as IconProp}/>
          </div>
          <span className="label">Envie uma mensagem</span>
        </div>
      </div>
      </>
  )
}
